module.exports = __webpack_public_path__ + "static/media/licenta21.e99ece29.png";